import React, { forwardRef } from 'react';

const base =
  'w-full px-4 py-3 text-base border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed';

const Input = forwardRef(function Input(
  { error = false, className = '', type = 'text', ...props },
  ref
) {
  const borderClass = error
    ? 'border-red-400 focus:ring-red-400'
    : 'border-gray-300';

  return (
    <input
      ref={ref}
      type={type}
      className={`${base} ${borderClass} ${className}`}
      {...props}
    />
  );
});

export default Input;
